import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '精选文章', path: '/articles' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '情感陪伴', path: '/articles?category=emotional-companion' },
    { label: '品质生活', path: '/articles?category=quality-life' },
    { label: '心灵成长', path: '/articles?category=soul-growth' },
    { label: '关系经营', path: '/articles?category=relationship' },
  ],
  contact: {
    email: 'hello@jiujiuyiren.com',
    phone: '400-888-9999',
    address: '上海市静安区南京西路1788号久久大厦',
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block font-heading text-xl font-bold tracking-wide mb-5 text-background-50 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
              久久伊人
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mt-3 max-w-xs">
              专注情感陪伴与品质生活，以真诚与用心守护每一段珍贵关系，让美好情感久久延续。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">快速导航</h4>
            <ul className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">内容分类</h4>
            <ul className="space-y-3">
              {footerLinks.categories.map((cat) => (
                <li key={cat.path}>
                  <Link
                    to={cat.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <a href={`mailto:${footerLinks.contact.email}`} className="hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  {footerLinks.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-accent-400" />
                <a href={`tel:${footerLinks.contact.phone}`} className="hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  {footerLinks.contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400" />
                <span>{footerLinks.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 久久伊人 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}